import React, { useEffect, useState } from "react";
import './App.css';

const Games = () => {
    const [gamesData, setGameData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchGames = async () => {
            try {
                setLoading(true);
                setError('');
                
                const response = await fetch("/games");
                
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                
                const data = await response.json();
                console.log('Games data received:', data); // Debug log
                setGameData(data);
                
            } catch (error) {
                console.error('Error fetching games:', error);
                setError('Failed to load games. Please try again later.');
            } finally {
                setLoading(false);
            }
        };

        fetchGames();
    }, []);

    if (loading) {
        return (
            <div className="text-center">
                <h1>Games & Descriptions</h1>
                <p>Loading games...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="text-center">
                <h1>Games & Descriptions</h1>
                <div className="error-message">
                    {error}
                </div>
            </div>
        );
    }

    return (
        <div className="fade-in">
            <h1>Games & Descriptions</h1>
            
            {gamesData.length === 0 ? (
                <p className="text-center">No games available at this time.</p>
            ) : (
                <table className="schedule-table full-width">
                    <thead>
                        <tr>
                            <th>Game Title</th>
                            <th>Description</th>
                        </tr>
                    </thead>
                    <tbody>
                        {gamesData.map((game) => (
                            <tr key={game.id}>
                                {/* Fixed: Using 'title' from your backend response */}
                                <td>{game.title || game.displayName || 'Unknown Game'}</td>
                                <td>{game.description || 'No description available'}</td>
                            </tr>
                        ))}   
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default Games;
